<template>
    <div class="channelPrice">
        <div class="blueInfo">
            <p>1.渠道票价：车票价格 + 渠道服务费比例 × 车票价格，若最终票价存在小数则向上取整，例如16.8元取整为17元</p>
            <p>2.修改服务费比例后，用户查询班次时，将按最新的价格返回给渠道商（巴士快线）</p>
        </div>
        <div class="channelPrice-content">
            <div class="flex-between channelPrice-title">
                <span>巴士快线（同程）</span>
                <div v-if="btnPreFn('line_channel_fee', false)">
                    <el-button type="primary" @click="editChannelPrice" v-if="!isEdit">编辑</el-button>
                </div>
            </div>
            <el-form ref="channelForm" label-width="100px" :model="channelForm" :rules="channelRules">
                <el-form-item label="服务费比例" prop="channelTcServiceFee" >
                    <el-input v-model="channelForm.channelTcServiceFee" :disabled="!isEdit"
                        v-input-filter="{ precision: 0, min: 0, max: 100 }">
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <div v-if="isEdit">
                        <el-button @click="cancelChannelPrice">取消</el-button>
                        <el-button type="primary" @click="saveChannelPrice">保存</el-button>
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
    <!--  -->
</template>

<script>
export default {
    data() {
        return {
            id: this.$route.query.id,
            channelForm: {
                channelTcServiceFee: ''
            },
            channelRules: {
                channelTcServiceFee: [{ required: true, message: '请输入同程服务费比例' }],
            },
            isEdit: false,
        }
    },
    created() {
        this.getInfo()
    },
    methods: {
        async getInfo() {
            if (!this.id) {
                return false;
            }
            let url = "/api/v1/manage/line/" + this.id;
            let { code, data } = await this.$axios.get(url);
            if (code === 1 && data?.stationVoList) {
                this.oldChannelTcServiceFee = data.channelTcServiceFee
                this.channelForm = {...data};
            }
        },
        editChannelPrice() {
            this.isEdit = true
        },
        cancelChannelPrice() {
            this.isEdit = false;
            this.channelForm.channelTcServiceFee = this.oldChannelTcServiceFee;
        },
        async saveChannelPrice() {
            this.$refs.channelForm.validate(async (valid) => {
                if (valid) {
                    let url = "/api/v1/manage/line/channelServiceFee"
                    let data = await this.$axios.post(url, {
                        lineId: this.id,
                        channelTcServiceFee: this.channelForm.channelTcServiceFee || 0
                    })
                    if (data && data.code === 1) {
                        this.$message.success('保存成功')
                        this.isEdit = false
                    }
                }
            })
        },
    }
}
</script>

<style lang="less" scoped>
.channelPrice {

    .channelPrice-content {
        width: 400px;

        .channelPrice-title {
            margin-bottom: 20px;
            font-size: 16px;
            font-weight: bold;
            color: #333;
        }
    }
}
</style>
